/**
 * Recorded answer for tri-state inspection items.
 * Values are stored as strings in the database.
 *
 * A null value means the item was never answered, which is distinct from NotApplicable.
 *
 * These values must match the backend enum exactly:
 * - Backend: Leo.Cars.Raptor.Model/Inspections/TriStateValue.cs
 */
export enum TriStateValue {
    /**
     * The work was performed or the condition holds
     */
    Yes = 'Yes',

    /**
     * The inspector deliberately recorded that the item did not apply
     */
    NotApplicable = 'NotApplicable',

    /**
     * The work was not performed or the condition does not hold
     */
    No = 'No',
}
